import * as React from 'react';
import {ApolloProvider} from 'react-apollo';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {Router} from 'react-router-dom';

import {ApolloProvider as ReactHooksApolloProvider} from '@apollo/react-hooks';

import {nutApolloClient} from '../../../apollo-client';
import {appHistory} from '../../../history';
import {store} from '../../../store';

import {UserPageBanners} from './banners/user-page-banners';

const USER_PAGE_BANNERS_REACT_MOUNT_ID = 'user-page-banners-mount-for-react';

export function mountUserPageBanners() {
    const mount = document.getElementById(USER_PAGE_BANNERS_REACT_MOUNT_ID);

    const showLicenseBanner = Boolean(mount && mount.dataset.userHasLicense === 'false');
    const showDsManagedUserBanner = Boolean(mount && mount.dataset.userIsFromDs === 'true');

    if (mount) {
        ReactDOM.render(
            <Provider store={store}>
                <ApolloProvider client={nutApolloClient}>
                    <ReactHooksApolloProvider client={nutApolloClient}>
                        <Router history={appHistory}>
                            <UserPageBanners
                                showLicenseBanner={showLicenseBanner}
                                showDsManagedUserBanner={showDsManagedUserBanner}
                            />
                        </Router>
                    </ReactHooksApolloProvider>
                </ApolloProvider>
            </Provider>,
            mount
        );
    }
}
